import React, { useEffect, useState } from "react";
import ResultCard from "./ResultCard";
import StartInfoCard from "./StartInfoCard";
import Map from "./Map";
import getCurrentDateForRequest from "../utils/get-formatted-current-date";

const AnalyseTool = () => {
    const [ifServiceAreaResolved, setIfServiceAreaResolved] = useState(false);
    const [ifServiceAreaStatsQueried, setIfServiceAreaStatsQueried] = useState(false);
    const [serviceAreaStatsArr, setServiceAreaStatsArr] = useState([]);
    const [poiInServiceAreaArr, setPoiInServiceAreaArr] = useState([])
    const [mapView, setMapView] = useState(null);
    const [cutoffs, setCutoffs] = useState([0.5, 0.75, 1]);
    const [todayDate, setTodayDate] = useState(""); // to store initial value for reset
    const [queryDate, setQueryDate] = useState("");

    useEffect(
        () => {
            const today = getCurrentDateForRequest();
            setTodayDate(today);
            setQueryDate(today);
        }, []
    );

    const handleReset = () => {
        setIfServiceAreaResolved(false);
        setIfServiceAreaStatsQueried(false);
        setServiceAreaStatsArr([]);
        setPoiInServiceAreaArr([]);
        setCutoffs([0.5, 0.75, 1]);
        setQueryDate(todayDate);
        mapView.graphics.removeAll();
    };

    return (
        <>
            {ifServiceAreaStatsQueried ?
                <ResultCard ifServiceAreaResolved={ifServiceAreaResolved}
                            serviceAreaStatsQueryResult={serviceAreaStatsArr} poisQueryResult={poiInServiceAreaArr} resetQuery={handleReset}></ResultCard> :
                <StartInfoCard cutoffArr={cutoffs} setCutoffs={setCutoffs} departureInfoQueryDate={queryDate}
                               setDepartureInfoQueryDate={setQueryDate} />}
            <Map
                setIfServiceAreaResolved={setIfServiceAreaResolved}
                setIfServiceAreaStatsQueried={setIfServiceAreaStatsQueried}
                serviceAreaCutoffs={cutoffs}
                setServiceAreaStats={setServiceAreaStatsArr}
                setPoiInServiceArea={setPoiInServiceAreaArr}
                departureInfoQueryDate={queryDate}
                view={mapView}
                setView={setMapView}
            />
        </>
    )
}

export default AnalyseTool;
